// By Default
import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { FiAlertTriangle } from "react-icons/fi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  boxShadow:
    "0 4px 12px rgba(16,69,70,0.08), 0 12px 28px rgba(16,69,70,0.08)",
  border: "1px solid #E5E9EB",
  borderRadius: "20px",
  outline: "none",
};

export default function DeleteModal({ Open, setOpen, onSubmit, Loading }) {
  return (
    <div>
      <Modal
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
        open={Open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 250,
            sx: { backgroundColor: "rgba(16,36,38,0.45)" },
          },
        }}
      >
        <Fade in={Open}>
          <Box sx={style}>
            <div
              id="delete-modal-title"
              className="bg-white text-ink p-8 w-[460px] max767:w-[92vw] flex flex-col justify-center items-center font-quicksand rounded-2xl overflow-hidden"
            >
              <div className="w-14 h-14 rounded-full bg-dangerSoft flex items-center justify-center mb-4">
                <FiAlertTriangle className="text-danger" size={26} />
              </div>
              <div className="text-center text-xl max767:text-lg font-bold mb-2">
                Are you sure want to delete?
              </div>
              <p
                id="delete-modal-description"
                className="text-sm text-muted text-center mb-6"
              >
                This action cannot be undone.
              </p>
              <div className="bg-line h-px w-full" />
              <div className="flex flex-col w-full justify-center items-center gap-3 mt-6">
                <button
                  type="button"
                  className="w-full max-w-[297px] h-11 py-2 bg-danger hover:bg-danger/90 border-2 border-danger rounded-full text-white text-base font-bold transition-all duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed active:scale-[.98]"
                  onClick={onSubmit}
                  disabled={Loading}
                >
                  {Loading ? "Deleting..." : "Yes, Delete"}
                </button>
                <button
                  type="button"
                  className="w-full max-w-[297px] h-11 py-2 bg-white border-2 border-line rounded-full text-ink text-base font-bold hover:border-main hover:text-main transition-all duration-200 ease-in-out active:scale-[.98]"
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
